import React from 'react';

const CardIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="240"
      height="150"
      viewBox="0 0 239 150"
      {...props}
    >
      <defs>
        <clipPath id="clip1">
          <path d="M0 0H239V150H0z"></path>
        </clipPath>
        <g id="surface5" clipPath="url(#clip1)">
          <path
            fill="#F1B600"
            d="M52.105 66.934l-1.359-2.274 4.758-2.844h2.152l.114 15.57h2.488v2.727l-8.832.114V77.5h2.719l-.227-11.703zm0 0"
          ></path>
        </g>
        <clipPath id="clip2">
          <path d="M0 0H239V150H0z"></path>
        </clipPath>
        <g id="surface8" clipPath="url(#clip2)">
          <path
            fill="#F1B600"
            d="M78.27 51.363l-2.946-.453c.227-2.844 1.586-4.32 4.192-4.433 1.586-.114 2.718.226 3.625 1.023.793.797 1.359 2.047 1.359 3.523.113 1.25-.113 2.614-.68 4.09-.566 1.477-1.812 3.637-3.738 6.59l5.098-.34.113 2.614-8.836.57-.113-1.594c1.133-2.043 2.039-3.637 2.719-5 .68-1.363 1.132-2.387 1.359-3.293.226-.91.453-1.476.453-1.933v-1.59c-.113-1.59-.566-2.274-1.36-2.274-.453 0-.792.227-1.019.57 0 .34-.113.907-.226 1.93zm0 0"
          ></path>
        </g>
        <clipPath id="clip3">
          <path d="M0 0H239V150H0z"></path>
        </clipPath>
        <g id="surface11" clipPath="url(#clip3)">
          <path
            fill="#F1B600"
            d="M111.457 69.434c.113 2.043-.34 3.632-1.133 4.543-.793 1.023-2.152 1.476-3.851 1.59-2.832.117-4.532-1.364-5.098-4.544l3.172-.796c.226 1.023.453 1.707.68 2.16.34.34.68.566 1.132.566.454 0 .793-.226 1.02-.68.226-.457.34-1.363.226-2.613 0-1.594-.226-2.613-.566-3.07-.34-.453-1.02-.68-2.039-.68l-.113-2.844c.34 0 .68 0 .906-.113.227-.113.453-.113.68-.226a1.16 1.16 0 00.566-.68c.113-.344.113-.684.113-1.25 0-1.707-.566-2.613-1.359-2.613s-1.246.906-1.36 2.726l-3.398-.683c.227-1.704.793-2.954 1.7-3.637.906-.68 1.925-1.137 3.171-1.137 1.586 0 2.832.344 3.739 1.137.906.797 1.359 2.047 1.359 3.637 0 .91-.113 1.707-.567 2.5-.453.683-1.019 1.25-1.699 1.59.68.23 1.36.683 1.926 1.593.453.68.68 1.93.793 3.524zm0 0"
          ></path>
        </g>
        <clipPath id="clip4">
          <path d="M0 0H239V150H0z"></path>
        </clipPath>
        <g id="surface14" clipPath="url(#clip4)">
          <path
            fill="#F1B600"
            d="M134.68 46.59l.566 12.387 1.813-.114.113 2.727-1.813.113.114 3.297-3.172.113-.113-3.297-5.778.23-.113-1.706 4.644-13.524zm-5.325 12.613l2.72-.113-.34-7.156zm0 0"
          ></path>
        </g>
      </defs>
      <g>
        <path
          fill="#F1B600"
          d="M10.422 42.387l8.836-23.297 197.43-8.18 5.207 3.75 6.457 101.477-7.477 14.547-201.957 8.406-4.758-7.043zm0 0"
        ></path>
        <path
          fill="#FFF"
          d="M46.441 60.566l2.38-2.156 16.421.34 1.02 25.227-18.348.113-2.266-1.477zm0 0M70.227 44.887l3.171-2.5 16.426.566.453 25-18.011.797-2.493-1.703zm0 0M97.074 55.227l2.153-2.5 16.648.113 1.02 25.226-18.122.797-2.492-1.476zm0 0M121.426 45l2.832-2.16 16.535.344.68 24.882-18.121.797-2.38-1.59zm0 0M148.95 28.977l3.284-6.137 35.567-.68 5.21 54.774-1.925 6.59-41.117 1.703zm0 0"
        ></path>
        <path
          fill="#583017"
          d="M12.914 103.863l213.965-9.886 1.7 22.16-214.645 10.91zm0 0"
        ></path>
        <use xlinkHref="#surface5"></use>
        <use xlinkHref="#surface8"></use>
        <use xlinkHref="#surface11"></use>
        <use xlinkHref="#surface14"></use>
        <path
          fill="#583017"
          d="M177.27 31.363l-20.391 1.364 1.473 20.683 2.832 1.817c2.832-.91 4.87-1.477 6.343-1.477 3.399-.113 4.305 2.16 4.645 8.184l.34 4.882c.34 4.887-1.02 6.25-2.719 6.368h-.113c-2.04.113-3.399-1.25-4.418-6.25l-7.703 2.156c1.812 8.637 6.796 10.57 12.12 10.344h.567c8.383-.57 12.117-5.57 11.55-13.868l-.339-4.203c-.793-10.797-4.867-14.547-10.418-14.316-1.7.113-3.625.453-5.55 1.363l-.567-9.207 12.914-.906c0-.113-.566-6.934-.566-6.934zm0 0"
        ></path>
      </g>
    </svg>
  );
};

export default CardIcon;
